module.exports = __webpack_public_path__ + "static/assets/john-smith-profile.9d47b2a.png";